import { en } from './en.js'

export const es = structuredClone(en)

es.visualGameAdmin.conversionFunnelDevices = {'label': 'Dispositivos de origen', 'all': 'Todos', 'desktop': 'Ordenador', 'mobile': 'Móvil', 'tablet': 'Tableta'}

es.visualGameAdmin.pageFunnel = {'button': 'Ver embudo de páginas', 'title': 'Embudo de páginas', 'home': 'Inicio', 'auth': 'Acceso o registro', 'game': 'Página de juego', 'note': 'Sesiones que recorren los pasos en orden según fecha y dispositivo. Incluye el diálogo de acceso del PC. No se recuperan aperturas históricas sin seguimiento.', 'loading': 'Cargando…', 'error': 'Error al cargar', 'sessions': 'sesiones'}

es.visualGameAdmin.pageFunnel.viewUsers = 'Ver usuarios'
es.visualGameAdmin.pageFunnel.peopleUnit = 'usuarios'
es.visualGameAdmin.pageFunnel.timesUnit = 'veces'

es.visualGameAdmin.pageFunnel.userFilter_all = 'Embudo: registros o accesos'

es.visualGameAdmin.pageFunnel.userFilter_sign_up = 'Embudo: registros del período'

es.visualGameAdmin.pageFunnel.userFilter_login = 'Embudo: accesos del período'

es.visualGameAdmin.usageActivity = {
  "title": "Uso del sitio · Actividad",
  "button": "Ver detalles",
  "all": "Todas las actividades",
  "search": "Buscar usuario, juego o ID",
  "user": "Usuario",
  "game": "Juego",
  "kind": "Actividad",
  "status": "Estado",
  "time": "Fecha",
  "detail": "Ver registro",
  "empty": "No hay registros",
  "loading": "Cargando…",
  "error": "Error al cargar",
  "note": "Las entradas usan eventos propios y pueden diferir de GA4. No se infieren textos ni partidas no registrados.",
  "limit": "Se muestran los últimos 1000 registros. Reduzca el intervalo para ver otros.",
  "text_input": "Entrada de texto",
  "voice_input": "Entrada de voz",
  "slice_video": "Generación de clip",
  "global_video": "Generación de vídeo completo",
  "free_game": "Generación de juego gratis"
}

Object.assign(es.visualGameAdmin.usageActivity, {
  "status_queued": "En cola",
  "status_running": "En curso",
  "status_ready": "Completado",
  "status_failed": "Fallido",
  "status_submitting": "Enviando",
  "status_submitted": "Enviado",
  "status_ok": "Correcto",
  "status_error": "Fallido",
  "status_generating": "Generando",
  "status_generation_failed": "Generación fallida",
  "status_pending_review": "Pendiente de revisión",
  "status_review_rejected": "Rechazado",
  "status_published": "Publicado",
  "status_archived": "Archivado"
})

es.visualGameAdmin.usageActivity.records = 'registros'

es.visualGameAdmin.paypointActivity = {
  "title": "Puntos de pago · Detalles",
  "all": "Todos",
  "game": "Página",
  "kind": "Contexto de pago",
  "status": "Motivo",
  "note": "Los eventos propios pueden diferir de GA4. Abrir el diálogo de vídeo no indica saldo insuficiente. Los registros históricos no incluyen saldo, coste ni ID de partida.",
  "billing_paypoint_gameplay": "Juego",
  "billing_paypoint_ending_video": "Vídeo final",
  "billing_paypoint_story_video": "Vídeo de historia",
  "status_insufficient_balance": "Créditos insuficientes",
  "status_dialog_open": "Diálogo de generación abierto"
}

es.visualGameAdmin.paypointActivity.search = 'Buscar usuario, página o ID'

es.visualGameAdmin.orderDrilldown = {
  "button": "Ver pedidos",
  "dateField": "Referencia temporal",
  "created_at": "Fecha de creación",
  "paid_at": "Fecha de pago"
}

Object.assign(es.visualGameAdmin.orderDrilldown, {
  "since": "Fecha inicial",
  "until": "Fecha final"
})

es.visualGameAdmin.orderDrilldown.updated_at = 'Fecha de actualización del estado'

es.visualGameAdmin.trafficBaseline = {
  "confirmed": "Incremento confirmado",
  "first": "Vistas iniciales (sin confirmar)",
  "missing": "Sin referencia; incremento incompleto",
  "note": "Sin una captura anterior al período, las vistas iniciales se muestran aparte y se excluyen del incremento confirmado. La fecha de observación no es la de publicación.",
  "observed": "Primera observación",
  "filter": "Sin referencia",
  "unchanged": "Sin crecimiento (referencia completa)",
  "later": "Crecimiento tras primera observación"
}
